import * as DataLoader from "./dataLoader";
import * as State from "./state";
import * as Theme from "./theme";
import * as UI from "./ui";

//Initialize app
const init = () => {
  // Initialize DOM
  UI.initDOMElements();

  // Initialize theme
  Theme.initTheme();

  // Load quiz data
  State.state.quizzes = DataLoader.loadQuizData();

  // Setup event listeners
  setupEventListeners();
};

/**
 *Set up all event listeners
 */
const setupEventListeners = () => {
  // Start menu - quiz selection buttons
  const quizButtons = document.querySelectorAll("[data-subject]");
  quizButtons.forEach((button) => {
    button.addEventListener("click", handleQuizSelection);
  });

  // Question section - answer buttons
  const answerButtons = document.querySelectorAll('[role="radio"]');
  answerButtons.forEach((button) => {
    button.addEventListener("click", handleAnswerSelection);
  });

  // Question section - submit button
  const submitButton = document.getElementById("submit-answer-button");
  submitButton.addEventListener("click", handleSubmit);

  // Score section - play again button
  const playAgainButton = document.getElementById("play-again-button");
  playAgainButton.addEventListener("click", handlePlayAgain);
};

/**
 * Handles quiz selection from start menu
 * @param {Event} event - click event
 */
const handleQuizSelection = (event) => {
  const subject = event.currentTarget.dataset.subject;

  // Load selected quiz
  const quiz = DataLoader.getQuizByTitle(subject);
  if (!quiz) {
    console.error(`Quiz not found: ${subject}`);
    return;
  }

  // Update state
  State.state.currentQuiz = quiz;
  State.state.currentQuestionIndex = 0;
  State.state.score = 0;

  // Update UI
  UI.hideSection("start-menu-section");
  UI.showSection("questions-section");
  UI.updateHeaderSubject(quiz.title);
  UI.showSelectedSubjectHeader();

  // Render first question
  const firstQuestion = quiz.questions[0];
  UI.renderQuestion(firstQuestion, 1, quiz.questions.length);
};

/**
 * Handles answer selection
 * @param {Event} event - Click event
 */
const handleAnswerSelection = (event) => {
  // Don't allow selection after submission
  if (State.state.isAnswerSubmitted) {
    return;
  }

  const selectedButton = event.currentTarget;
  const answerText = selectedButton.querySelector(".answer-text").textContent;

  // Update state
  State.selectAnswer(answerText);

  // Update UI
  UI.highlightSelectedAnswer(selectedButton);
  UI.toggleSubmitButton(true);
  UI.hideErrorMessage();
};

/**
 * Handles submit button click
 */
const handleSubmit = () => {
  console.log("🟡 handleSubmit called");
  console.log("Selected answer:", State.state.selectedAnswer);
  // Check if answer is selected
  if (!State.state.selectedAnswer) {
    console.log("❌ No answer selected, showing error");
    UI.showErrorMessage();
    return;
  }

  // If already submitted, move to next question
  if (State.state.isAnswerSubmitted) {
    moveToNextQuestion();
    return;
  }

  // Submit answer
  const isCorrect = State.submitAnswer();

  // Get current question for correct answer
  const currentQuestion =
    State.state.currentQuiz.questions[State.state.currentQuestionIndex];

  // Find selected button
  const answerButtons = document.querySelectorAll('[role="radio"]');
  let selectedButton = null;
  answerButtons.forEach((btn) => {
    if (
      btn.querySelector(".answer-text").textContent ===
      State.state.selectedAnswer
    ) {
      selectedButton = btn;
    }
  });

  // Show feedback
  UI.showAnswerFeedback(selectedButton, currentQuestion.answer, isCorrect);

  // Change button text to "Next Question"
  UI.updateSubmitButtonText("Next Question");
};

/**
 * Moves to next question or shows score
 */
const moveToNextQuestion = () => {
  // Move to next question in state
  State.nextQuestion();

  // Check if quiz is complete
  if (State.isQuizComplete()) {
    showScoreScreen();
    return;
  }

  // Render next question
  const nextQuestion =
    State.state.currentQuiz.questions[State.state.currentQuestionIndex];
  const questionNumber = State.state.currentQuestionIndex + 1;
  const totalQuestions = State.state.currentQuiz.questions.length;

  UI.renderQuestion(nextQuestion, questionNumber, totalQuestions);
};

/**
 * Shows the final score screen
 */
const showScoreScreen = () => {
  // Hide questions, show score
  UI.hideSection("questions-section");
  UI.showSection("score-section");

  // Render score
  UI.renderScoreScreen(
    State.state.currentQuiz.title,
    State.state.score,
    State.state.currentQuiz.questions.length,
  );
};

/**
 * Handles play again button click
 */
const handlePlayAgain = () => {
  // Reset state
  State.resetQuiz();

  // Reset UI
  UI.hideSection("score-section");
  UI.showSection("start-menu-section");
  UI.hideSelectedSubjectHeader();
};

// Start the app when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
